import { render, staticRenderFns } from "./message-text.vue?vue&type=template&id=038b5235&scoped=true"
import script from "./message-text.vue?vue&type=script&lang=ts&setup=true"
export * from "./message-text.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./message-text.vue?vue&type=style&index=0&id=038b5235&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "038b5235",
  null
  
)

export default component.exports